// apps/client/src/ui/hud/update-signals.ts
export const hudUpdateSignalsConfig = {
  VERSION_CHECK_TIMEOUT_MS: 10_000 as const,
};

// apps/client/src/ui/perf-probe.ts
export const hudPerfProbeConfig = {
  // Pure part of the HUD frame-time probe. No DOM, no storage. See hud/index.tsx for the install.
  PROBE_FRAMES: 3600,
  LONG_FRAME_MS: 20,
};

// apps/client/src/ui/hud/screens/settings/Settings.tsx
export const hudSettingsConfig = {
  GRAPHICS: ["Low", "Medium", "High"] as ("Low" | "Medium" | "High")[],
  PACES: ["Slow", "Normal", "Fast"] as ("Slow" | "Normal" | "Fast")[],
};

// apps/client/src/ui/hud/topbar-signals.ts
export const hudTopbarSignalsConfig = {
  // --- Weak connection (A3) ---------------------------------------------------
  // Own link health from client-side measurements only: the transport state, the
  // presentation starvation flag, and the adaptive interpolation buffer
  // (presentation.ts: NET_INTERP_MS 50, NET_INTERP_MAX_MS 500). A grown buffer
  // means views arrive late — the earliest weak-link sign, before starvation.
  // Calibration knobs, provisional pending play measurements.
  WEAK_INTERP_MS: 250 as const,
  // The server heartbeat reports every RTT_PROBE_MS (2 s in a match). A report
  // older than about three missed probes is stale: never present it as current.
  ALIVE_STALE_MS: 7000 as const,
  // Transition rule: a weak state holds this long after its cause clears, then
  // one recovery note shows for WEAK_RECOVERED_MS before the chip hides. No
  // flashing on a boundary case.
  WEAK_HOLD_MS: 2000 as const,
  WEAK_RECOVERED_MS: 2500 as const,
};

export const hudConfig = {
  alertLinesMax: 4,
  alertHistoryMax: 6,
  alertFadeMs: 4500,
  alertDurationMs: 5000,
  errorCooldownSeconds: 1,
  queuedCooldownSeconds: 1,
  attackCooldownSeconds: 10,
  attackCooldownRadius: 300,
  attackPingMs: 5000,
  groupNameMax: 24,
  playerNameMax: 16,
  lobbyPollMs: 2000,
  chatLinesMax: 100,
  chatStripLinesMax: 4,
  chatDurationMs: 10000,
  chatFadeStartMs: 7500,
  chatFadeMs: 2500,
  pingDurationMs: 5000,
};

export const matchDurationOptions = [
  { label: "∞", value: null },
  { label: "10m", value: 600 },
  { label: "20m", value: 1200 },
  { label: "30m", value: 1800 },
  { label: "60m", value: 3600 },
] as const;

export const matchPopulationOptions = [
  { label: "∞", value: null },
  { label: "60", value: 60 },
  { label: "100", value: 100 },
  { label: "150", value: 150 },
] as const;

export const chatPresentationConfig = {
  refreshMs: 200,
};
